import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IBusinessUnit } from 'src/app/business-unit/businessunit';
import { IEvaluation } from 'src/app/evaluation/evaluation';
import { BusinessunitlistService } from 'src/app/services/businessunit/businessunitlist.service';
import { CompanylistService } from 'src/app/services/company/companylist.service';
import { EvaluationlistService } from 'src/app/services/evaluation/evaluationlist.service';
import { ReportService } from 'src/app/services/reports/report.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-employeeteam',
  templateUrl: './employeeteam.component.html',
  styleUrls: ['./employeeteam.component.css']
})
export class EmployeeteamComponent implements OnInit {

  evaluation: IEvaluation[];
  _evaluation: IEvaluation[];
  businessunit: any;
  _businessunit: any;
  plant: any;
  _plant: any;
  employeeteam: any;
  _employeeteam: any;
  eventcode: any;
  _eventcode: any;
  disableReportBtn: boolean = true;
  shreport: boolean = false;
  filBusinessUnitName: any;
  filEvaluationName: any;
  filFromDate: any;
  filToDate: any;
  filPlantName: any;
  filCompanyName: any;
  filEventCode: any;
  filJuryName: any;
  filEventDate: any;
  filEmployeeTeam: any;
  report_data: any;
  feedback_data: any;
  disrec: boolean = false;

  PDFevaluation_id: any;
  PDFEventCode: any;
  PDFbusinessunit_id: any;
  PDFplant_id: any;
  PDFEmployeeTeam: any;
  PDFfromDate: any;
  PDFtoDate: any;
  evType: any;

  url: string = environment.api_url;
  img_url: string = environment.url;

  constructor(private evaluationservice: EvaluationlistService, private businessunitlistService: BusinessunitlistService, private reportapi: ReportService, private companylistService: CompanylistService) { }

  @ViewChild('evaluationSearch') evaluationSearchInput: ElementRef;
  @ViewChild('plantSearch') plantSearchInput: ElementRef;
  @ViewChild('eventCodeSearch') eventCodeSearchInput: ElementRef;
  @ViewChild('employeeTeamSearch') employeeTeamSearchInput: ElementRef;
  @ViewChild('businessUnitSearch') businessUnitSearchInput: ElementRef;
  @ViewChild('companySearch') companySearchInput: ElementRef;

  @ViewChild('reportForm') reportForm: NgForm;

  ngOnInit(): void {

    this.evaluationservice.evaluationData().subscribe((data: IEvaluation[]) => {
      this.evaluation = data;
      this._evaluation = data;
    });

    this.businessunitlistService.businessUnitData().subscribe((data: IBusinessUnit[]) => {
      this.businessunit = data;
      this._businessunit = data;
    });

  }

  onfocusEvaluation() {
    this.evaluationSearchInput.nativeElement.focus();
  }
  onInputChangeEvaluation() {
    const searchInput = this.evaluationSearchInput.nativeElement.value ? this.evaluationSearchInput.nativeElement.value.toLowerCase() : '';
    this.evaluation = this._evaluation.filter(c_data => {
      const c_name: any = c_data.evaluationName.toLowerCase();
      return c_name.indexOf(searchInput) > -1;
    })
  }

  onfocusBusinessUnit() {
    this.businessUnitSearchInput.nativeElement.focus();
  }
  onInputChangeBusinessUnit() {
    const searchInput = this.businessUnitSearchInput.nativeElement.value ? this.businessUnitSearchInput.nativeElement.value.toLowerCase() : '';
    this.businessunit = this._businessunit.filter(c_data => {
      const c_name: any = c_data.businessUnitName.toLowerCase();
      return c_name.indexOf(searchInput) > -1;
    })
  }

  onfocusPlant() {
    this.plantSearchInput.nativeElement.focus();
  }
  onInputChangePlant() {
    const searchInput = this.plantSearchInput.nativeElement.value ? this.plantSearchInput.nativeElement.value.toLowerCase() : '';
    this.plant = this._plant.filter(c_data => {
      const c_name: any = c_data.plantName.toLowerCase();
      return c_name.indexOf(searchInput) > -1;
    })
  }

  onfocusEventCode() {
    this.eventCodeSearchInput.nativeElement.focus();
  }
  onInputChangeEventCode() {
    const searchInput = this.eventCodeSearchInput.nativeElement.value ? this.eventCodeSearchInput.nativeElement.value.toLowerCase() : '';
    this.eventcode = this._eventcode.filter(c_data => {
      const c_name: any = c_data.eventCode.toLowerCase();
      return c_name.indexOf(searchInput) > -1;
    })
  }

  onfocusEmployeeTeam() {
    this.employeeTeamSearchInput.nativeElement.focus();
  }
  onInputChangeEmployeeTeam() {
    const searchInput = this.employeeTeamSearchInput.nativeElement.value ? this.employeeTeamSearchInput.nativeElement.value.toLowerCase() : '';
    this.employeeteam = this._employeeteam.filter(c_data => {
      const c_name: any = c_data.employeeName.toLowerCase();
      return c_name.indexOf(searchInput) > -1;
    })
  }

  chgBusinessUnit(businessunit_id) {
    if(businessunit_id != "") {
      const formData = new FormData();
      formData.append('businessunit_id', businessunit_id);
      this.reportapi.plants(formData).subscribe((data: any) => {
        if(data.other['msz']) {
          this.plant = data.dataList;
          this._plant = data.dataList;
          this.eventcode = [];
          this._eventcode = [];
          this.reportForm.control.get('eventCode').reset();
          this.reportForm.control.get('plant').reset();
        } else {
          this.plant = [];
          this._plant = [];
          this.eventcode = [];
          this._eventcode = [];
          this.reportForm.control.get('eventCode').reset();
          this.reportForm.control.get('plant').reset();
        }
      });
    } else {
      this.plant = [];
      this._plant = [];
      this.eventcode = [];
      this._eventcode = [];
      this.reportForm.control.get('businessUnit').reset();
      this.reportForm.control.get('plant').reset();
      this.reportForm.control.get('eventCode').reset();
    }
  }

  chgPlant(plant_id) {

    if(plant_id != "") {
      const formData = new FormData();
      formData.append('closed_plant_id', plant_id);
      formData.append('f_evl_id', this.reportForm.controls['evaluation'].value);
      formData.append('f_bu_id', this.reportForm.controls['businessUnit'].value);
      this.reportapi.closedeventsCodes(formData).subscribe((data: any) => {
        if(data.other['msz']) {
          this.eventcode = data.dataList;
          this._eventcode = data.dataList;
        } else {
          this.eventcode = [];
          this._eventcode = [];
        }
      });
    } else {
      this.eventcode = [];
      this._eventcode = [];
      this.reportForm.control.get('eventCode').reset();
    }
  }

  chgevl(evl_id) {

    if(evl_id != "") {
      const formData = new FormData();
      formData.append('closed_plant_id', this.reportForm.controls['plant'].value);
      formData.append('f_evl_id', evl_id);
      formData.append('f_bu_id', this.reportForm.controls['businessUnit'].value);
      this.reportapi.closedeventsCodes(formData).subscribe((data: any) => {
        if(data.other['msz']) {
          this.eventcode = data.dataList;
          this._eventcode = data.dataList;
        } else {
          this.eventcode = [];
          this._eventcode = [];
        }
      });
    } else {
      this.eventcode = [];
      this._eventcode = [];
      this.reportForm.control.get('eventCode').reset();
    }
  }

  chgEventCode(eventcode_id) {
    if(eventcode_id != "") {
      const formData = new FormData();
      formData.append('eventCode_id', eventcode_id);
      this.reportapi.employeeTeam(formData).subscribe((data: any) => {
        if(data.ev_s)
        {
          this.disableReportBtn = false;
          if(data.other['msz']) {
            this.employeeteam = data.dataList;
            this._employeeteam = data.dataList;
          } else {
            this.employeeteam = [];
            this._employeeteam = [];
          }
        } else {
          this.disableReportBtn = false;
          this.employeeteam = [];
          this._employeeteam = [];
        }
      });
    } else {
      this.employeeteam = [];
      this._employeeteam = [];
      this.reportForm.control.get('employeeTeam').reset();
    }
  }


  chgEmployeeTeam(eventcode_id) {
    if(eventcode_id == "") {
      this.disableReportBtn = false;
      this.reportForm.control.get('employeeTeam').reset();
    }
  }

  submitReport(reportForm: NgForm){
    this.disableReportBtn = true;

    this.reportapi.employeeTeamReport(reportForm.form.value).subscribe((data) => {
      this.filBusinessUnitName = data.businessUnitName;
      this.filEvaluationName = data.evaluationName;
      this.filPlantName = data.plantName;
      this.filCompanyName = data.companyName;
      this.filEventCode = data.eventcode;
      this.filEventDate = data.eventdate;
      this.filJuryName = data.juries;
      this.filFromDate = data.rfromDate;
      this.filToDate = data.rtoDate;
      this.evType = data.evType;
      this.filEmployeeTeam = data.employeeTeam;

      this.PDFevaluation_id = data.field_data['evaluationId'];
      this.PDFEventCode = data.field_data['EventCode'];
      this.PDFbusinessunit_id = data.field_data['businessUnitId'];
      this.PDFplant_id = data.field_data['plantId'];
      this.PDFEmployeeTeam = data.field_data['EmployeeTeam'];
      this.PDFfromDate = data.field_data['fromDate'];
      this.PDFtoDate = data.field_data['toDate'];

      this.report_data = data.rep_data;
      this.feedback_data = data.jury_feedback;
      //console.log(this.report_data);

      if(data.records) {
        this.disrec = true;
      } else {
        this.disrec = false;
      }

      this.disableReportBtn = false;
      this.shreport = true;
    });
  }

}
